import { render, staticRenderFns } from "./ppoverview.vue?vue&type=template&id=25c408d1&scoped=true&"
import script from "./ppoverview.vue?vue&type=script&lang=js&"
export * from "./ppoverview.vue?vue&type=script&lang=js&"
import style0 from "./ppoverview.vue?vue&type=style&index=0&id=25c408d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c408d1",
  null
  
)

export default component.exports